import ViewBase from "../../../../framework/core/mvvm/view_base";
import Utility from "../../../../utility/utility";
import { CountUp } from "../../../../lib/countUp";
import { BgVipCell } from "./bg_vip_cell";

const {ccclass, property} = cc._decorator;

@ccclass
export class BgVipView extends ViewBase {

    @property([cc.Label])
    awardGold:cc.Label[] = [];//0 工资，1任务，2 充值

    @property(cc.Node)
    awardBtn:cc.Node = null;

    @property([BgVipCell])
    vipCell:BgVipCell[] = [];//0-银卡 1-金卡 2-黑金卡

    awardMap:Map<number,cc.Label> = null;

    vipCellMap:Map<string,BgVipCell> = null;

    onLoad(){
        this.awardMap = new Map<number,cc.Label>();
        this.awardMap.set(1,this.awardGold[1]);
        this.awardMap.set(2,this.awardGold[0]);
        this.awardMap.set(3,this.awardGold[2]);
        this.vipCellMap = new Map<string,BgVipCell>();
        this.vipCellMap.set('SYS_Vip_Scard',this.vipCell[0])
        this.vipCellMap.set('SYS_Vip_Gcard',this.vipCell[1])
        this.vipCellMap.set('SYS_Vip_Dcard',this.vipCell[2])
    }

    updateVip(viplist:any){
        for (let i = 0; i < this.vipCell.length; i++) {
            let vipcell =  this.vipCell[i];
            vipcell.updateCell(false);
        }
        if (viplist) {
            for (let j = 0; j < viplist.length; j++) {
                let data = viplist[j];
                let cell = this.vipCellMap.get(data.code);
                if (cell) {
                    let isOut =!data.remainTime || data.remainTime <= 0
                    cell.updateCell(!isOut,data);
                }
            }
        }
       
    }
    
    //更新vip 奖励
    updateVipAward(data:any){
        let isShowAwardBtn = false;
        this.resetVipAward();
        let award = {
            1:0,
            2:0,
            3:0,
        }
        for (let i = 0; i < data.length; i++) {
            let vipdata = data[i];
            award[vipdata.vipAwardType] += Number(vipdata.amount) 
            this.updateLab(award[vipdata.vipAwardType],vipdata.vipAwardType)
            if (vipdata.amount > 0) {
                isShowAwardBtn = true;
            }
        }

        Utility.setBtnGray(this.awardBtn.getComponent(cc.Button),!isShowAwardBtn)
    }

    resetVipAward(){
        this.awardMap.forEach((v:cc.Label,k:number)=>{
            v.string = '0';
        })
        Utility.setBtnGray(this.awardBtn.getComponent(cc.Button),true)
    }

    updateLab(gold:number,vipAwardType:number){
        let lab = this.awardMap.get(vipAwardType);
        if (lab && gold > 0) {
            lab.string = this.formatGold(gold)
        }
    }

    updateAwardGold(data:any){
        for (let i = 0; i < data.length; i++) {
           let vipAward = data[i];
            this.showNumbEffect(vipAward.amount,vipAward.vipAwardType);
        }
        Utility.setBtnGray(this.awardBtn.getComponent(cc.Button),true)
    }

    showNumbEffect(gold:number,vipAwardType){
        if (gold) {
            let chouma = new CountUp(null,0,{
                startVal: gold,
                decimalPlaces: 2,
                duration: 0.5,
                useEasing: false,
                useGrouping: false,
                smartEasingThreshold: 999,
                smartEasingAmount: 333,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            })
            if(!chouma.error){
                chouma.start((n)=>{
                    if (this.node && this.isValid) {
                        this.updateLab(Number(n),vipAwardType)
                    }
                })
            }
        }
    }

    currencyFormatting(money:number){
        return Math.floor(money * 1000 / 10) / 100
    }

    formatGold(money:number){
        if (money <= 0.001) {
            return '0';
        }
        let _money = this.currencyFormatting(money);
        return Utility.currencyFormatting(_money);
    }


}
